import { useRef } from "react"

import HeaderSearch from "./components/HeaderSearch"
import "./style.scss";
import { PrescriptiopnGlobalContext } from "../../../contexts/notas-medicas/prescriptionContext";
import NotasMedicasComponent from "../../../components/hb/notas-medicas";

const NotasMedicas = () => {
    const ref = useRef(null)
    return (
        <PrescriptiopnGlobalContext>
            <div className="d-flex help-page" ref={ref}>
                <NotasMedicasComponent />
            </div>
        </PrescriptiopnGlobalContext>
    )
}

export default NotasMedicas